module.exports = __webpack_public_path__ + "img/Childrens-hospital-trust-logo.34ed1989.jpg";